var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        class: {
          "container-telas-mobile": _vm.menuMobileAtivo,
          "d-none": _vm.isMobile && !_vm.menuMobileAtivo,
        },
      },
      [
        !_vm.isMobile
          ? _c("div", { staticClass: "header" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "justify-content": "space-between",
                    "align-items": "center",
                  },
                },
                [
                  _c("div", { staticStyle: { width: "70%" } }, [
                    !_vm.precoOriginalFormatado && _vm.precoLabel
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              "line-height": "14px",
                              display: "block",
                            },
                          },
                          [_vm._v(_vm._s(_vm.precoLabel))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.precoOriginalFormatado
                      ? _c("span", { staticClass: "preco-original" }, [
                          _vm._v(_vm._s(_vm.precoOriginalFormatado)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h2", { style: { color: _vm.corPrimaria } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.precoFormatado) +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "30%",
                        "text-align": "right",
                        "font-size": "12px",
                        color: "#A8A8A8",
                      },
                    },
                    [
                      _vm.isDiscount
                        ? _c("span", [_vm._v("À vista")])
                        : _vm.maxInstalments > 0 && _vm.showInstalment
                        ? _c("span", [
                            _vm._v(
                              "Em até " +
                                _vm._s(_vm.maxInstalments) +
                                "x no cartão"
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "body" },
          [
            _c("input-tickets", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step <= 0,
                  expression: "step <= 0",
                },
              ],
              attrs: {
                options: _vm.availableAgeRanges,
                min: _vm.quantidadeMinVenda,
                max: _vm.quantidadeMaxVenda,
                "nome-item": _vm.$props.nomeItem,
                "only-same-date": _vm.onlySameDate,
                "calendar-size": _vm.calendarSize,
                "combo-date": _vm.comboDate,
                "combo-id": _vm.passeioId,
                "initial-available-days": _vm.initialAvailableDays,
                "is-mobile": _vm.isMobile,
                moeda: _vm.moeda,
                "sub-total": _vm.subtotal + _vm.totalOpcionais,
                "n-root-steps": _vm.nSteps,
                "n-activities": _vm.activities.length,
              },
              on: {
                "on-complience-state-change": _vm.complienceChange,
                next: _vm.nextStep,
                previus: _vm.previusStep,
                "dom-height-change": _vm.emitHeightUpdate,
                "combo-date-selected": _vm.selectComboDate,
              },
              model: {
                value: _vm.selectedAgeRanges,
                callback: function ($$v) {
                  _vm.selectedAgeRanges = $$v
                },
                expression: "selectedAgeRanges",
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.activities, function (ac, i) {
              return _c("activity-step", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step == i + 1,
                    expression: "step == i+1",
                  },
                ],
                key: i,
                attrs: {
                  value: ac,
                  active: _vm.step == i - 1,
                  "primary-color": _vm.corPrimaria,
                  "calendar-size": _vm.calendarSize,
                  "show-remaining-vacancies": _vm.showRemainingVacancies,
                  "titulo-atividade": _vm.tituloAtividade,
                  "genero-titulo-atividade": _vm.generoTituloAtividade,
                  "selected-age-ranges": _vm.selectedAgeRanges,
                  "n-pessoas": _vm.nPessoas,
                  moeda: _vm.moeda,
                  "only-same-date": _vm.onlySameDate,
                  "schedule-conflict": _vm.getFirstConflictOf(ac.id),
                  "is-mobile": _vm.isMobile,
                  "sub-total": _vm.subtotal + _vm.totalOpcionais,
                  "n-root-steps": _vm.nSteps,
                  "n-steps-before": _vm.nStepsBeforeActivities + _vm.step,
                },
                on: {
                  input: (value) => _vm.updateActivity(value, i),
                  next: _vm.nextStep,
                  previus: _vm.previusStep,
                  "dom-height-change": _vm.emitHeightUpdate,
                },
              })
            }),
            _vm._v(" "),
            _c("finish-screen", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step > _vm.activities.length,
                  expression: "step > activities.length",
                },
              ],
              attrs: {
                prices: _vm.selectedPrices,
                activities: _vm.activities,
                "nome-item": _vm.nomeItem,
                "disable-finish": !_vm.isReady || _vm.isSubmitting,
                "has-schedule-conflicts": _vm.scheduleConflicts.length > 0,
                "primary-color": _vm.corPrimaria,
                moeda: _vm.moeda,
                "is-mobile": _vm.isMobile,
                "n-root-steps": _vm.nSteps,
                "sub-total": _vm.subtotal + _vm.totalOpcionais,
              },
              on: { finish: _vm.submit, previus: _vm.previusStep },
            }),
            _vm._v(" "),
            _vm.$props.hasPaymentPartial && !_vm.$props.isMobile
              ? _c("alerta-pagamento-parcial", {
                  attrs: {
                    "preco-parcial-label": _vm.$props.precoParcial,
                    "porcentagem-parcial": _vm.$props.porcentagemParcial,
                    total: _vm.subtotal + _vm.totalOpcionais,
                    moeda: _vm.$props.moeda,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isMobile && (_vm.descontoPeriodo > 0 || _vm.hasOptionals)
              ? _c("resumo-compra", {
                  staticStyle: { "margin-top": "25px" },
                  attrs: {
                    total: _vm.totalSemDesconto,
                    opcionais: _vm.totalOpcionais,
                    desconto: _vm.descontoPeriodo,
                    moeda: _vm.moeda,
                  },
                })
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        !_vm.isMobile
          ? _c("div", { staticClass: "footer" }, [
              _c(
                "strong",
                {
                  key: "subtotal_" + _vm.subtotal,
                  staticStyle: { visibility: "hidden", display: "block" },
                  style: { visibility: _vm.isMounted ? "visible" : "hidden" },
                },
                [
                  _vm._v(
                    "Subtotal: " +
                      _vm._s(_vm.formatMoney(_vm.subtotal + _vm.totalOpcionais))
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.$props.discountByPaymentMethod
                ? _c(
                    "span",
                    {
                      key: "totalDesconto_" + _vm.totalDesconto,
                      staticStyle: { display: "none", color: "#2FB97A" },
                      style: {
                        display:
                          _vm.isMounted && _vm.totalDesconto < _vm.subtotal
                            ? "block"
                            : "none",
                      },
                    },
                    [
                      _vm._v(
                        "Pagando no " +
                          _vm._s(_vm.discountPaymentMethodsLabel || "Pix") +
                          ": " +
                          _vm._s(
                            _vm.formatMoney(
                              _vm.totalDesconto + _vm.totalOpcionais
                            )
                          )
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    !_vm.menuMobileAtivo
      ? _c(
          "div",
          { staticClass: "footer-container-alert-partial-payment" },
          [
            _vm.$props.hasPaymentPartial && _vm.$props.isMobile
              ? _c("alerta-pagamento-parcial", {
                  attrs: {
                    "preco-parcial-label": _vm.$props.precoParcial,
                    "porcentagem-parcial": _vm.$props.porcentagemParcial,
                    total: _vm.subtotal + _vm.totalOpcionais,
                    moeda: _vm.$props.moeda,
                    "is-mobile": true,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isMobile && !_vm.menuMobileAtivo
      ? _c("div", { staticClass: "footer-container-mobile" }, [
          !_vm.menuMobileAtivo
            ? _c("div", { staticClass: "container-resumo" }, [
                _c("div", { staticClass: "container-precos" }, [
                  !_vm.precoOriginalFormatado && _vm.precoLabel
                    ? _c("small", { staticStyle: { color: "#8D8D8D" } }, [
                        _vm._v(_vm._s(_vm.precoLabel)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.precoOriginalFormatado
                    ? _c(
                        "small",
                        {
                          staticStyle: {
                            color: "#8D8D8D",
                            "text-decoration": "line-through",
                          },
                        },
                        [_vm._v("De " + _vm._s(_vm.precoOriginalFormatado))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "strong",
                    { style: { color: _vm.corPrimaria, "font-size": "20px" } },
                    [
                      _vm._v(
                        _vm._s(_vm.precoOriginalFormatado ? "Por " : "") +
                          _vm._s(_vm.precoFormatado)
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.$props.discountByPaymentMethod &&
                  _vm.precoDescontoFormatado
                    ? _c("small", { staticStyle: { color: "#3B9A5A" } }, [
                        _vm._v(
                          _vm._s(_vm.precoDescontoFormatado) +
                            " Pagando no " +
                            _vm._s(_vm.discountPaymentMethodsLabel || "Pix")
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "container-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-reservar",
                      style: { "background-color": _vm.corPrimaria },
                      on: {
                        click: function ($event) {
                          _vm.menuMobileAtivo = true
                        },
                      },
                    },
                    [_vm._v("\n          Reservar\n        ")]
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }